// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/sans/SourceSansPro-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/news-gothic/NewsGothicStd.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "SourceSansPro-Regular";
  src: local("SourceSansPro-Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
}

@font-face {
  font-family: "newsGothic-std";
  src: local("newsGothic-std"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("opentype");
}

/* @font-face {
  font-family: "sans";
  src: local("sans"),
    url("./assets/fonts/sans/SourceSansPro-BlackIt.otf") format("opentype");
  font-style: italic;
}

@font-face {
  font-family: "sans";
  src: local("sans"),
    url("./assets/fonts/sans/SourceSansPro-Bold.otf") format("opentype");
  font-weight: bold;
}

@font-face {
  font-family: "sans";
  src: local("sans"),
    url("./assets/fonts/sans/SourceSansPro-BoldIt.otf") format("opentype");
  font-weight: bold;
  font-style: italic;
}

/* @font-face {
  font-family: "Roobert";
  src: local("Roobert"),
    url("./assets/fonts/Roobert/Roobert-Heavy.otf") format("opentype");
  font-weight: bolder;
}

@font-face {
  font-family: "Roobert";
  src: local("Roobert"),
    url("./assets/fonts/Roobert/Roobert-HeavyItalic.otf") format("opentype");
  font-weight: bolder;
  font-style: italic;
} 

@font-face {
  font-family: "sans";
  src: local("sans"),
    url("./assets/fonts/sans/SourceSansPro-ExtraLight.otf") format("opentype");
  font-weight: lighter;
}

@font-face {
  font-family: "sans";
  src: local("sans"),
    url("./assets/fonts/sans/SourceSansPro-ExtraLightIt.otf") format("opentype");
  font-weight: lighter;
  font-style: italic;
}

@font-face {
  font-family: "sans";
  src: local("sans"),
    url("./assets/fonts/sans/SourceSansPro-Light.otf") format("opentype");
  font-weight: 300;
}

@font-face {
  font-family: "sans";
  src: local("sans"),
    url("./assets/fonts/sans/SourceSansPro-LightIt.otf") format("opentype");
  font-weight: 300;
  font-style: italic;
}

@font-face {
  font-family: "sans";
  src: local("sans"),
    url("./assets/fonts/sans/SourceSansPro-Semibold.otf") format("opentype");
  font-weight: 700;
}

@font-face {
  font-family: "sans";
  src: local("sans"),
    url("./assets/fonts/sans/SourceSansPro-SemiboldIt.otf") format("opentype");
  font-weight: 700;
  font-style: italic;
} */
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC;8DACyE;AAC3E;;AAEA;EACE,6BAA6B;EAC7B;8DACwE;AAC1E;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAgFG","sourcesContent":["@font-face {\r\n  font-family: \"SourceSansPro-Regular\";\r\n  src: local(\"SourceSansPro-Regular\"),\r\n    url(\"./assets/fonts/sans/SourceSansPro-Regular.otf\") format(\"opentype\");\r\n}\r\n\r\n@font-face {\r\n  font-family: \"newsGothic-std\";\r\n  src: local(\"newsGothic-std\"),\r\n    url(\"./assets/fonts/news-gothic/NewsGothicStd.otf\") format(\"opentype\");\r\n}\r\n\r\n/* @font-face {\r\n  font-family: \"sans\";\r\n  src: local(\"sans\"),\r\n    url(\"./assets/fonts/sans/SourceSansPro-BlackIt.otf\") format(\"opentype\");\r\n  font-style: italic;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"sans\";\r\n  src: local(\"sans\"),\r\n    url(\"./assets/fonts/sans/SourceSansPro-Bold.otf\") format(\"opentype\");\r\n  font-weight: bold;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"sans\";\r\n  src: local(\"sans\"),\r\n    url(\"./assets/fonts/sans/SourceSansPro-BoldIt.otf\") format(\"opentype\");\r\n  font-weight: bold;\r\n  font-style: italic;\r\n}\r\n\r\n/* @font-face {\r\n  font-family: \"Roobert\";\r\n  src: local(\"Roobert\"),\r\n    url(\"./assets/fonts/Roobert/Roobert-Heavy.otf\") format(\"opentype\");\r\n  font-weight: bolder;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Roobert\";\r\n  src: local(\"Roobert\"),\r\n    url(\"./assets/fonts/Roobert/Roobert-HeavyItalic.otf\") format(\"opentype\");\r\n  font-weight: bolder;\r\n  font-style: italic;\r\n} \r\n\r\n@font-face {\r\n  font-family: \"sans\";\r\n  src: local(\"sans\"),\r\n    url(\"./assets/fonts/sans/SourceSansPro-ExtraLight.otf\") format(\"opentype\");\r\n  font-weight: lighter;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"sans\";\r\n  src: local(\"sans\"),\r\n    url(\"./assets/fonts/sans/SourceSansPro-ExtraLightIt.otf\") format(\"opentype\");\r\n  font-weight: lighter;\r\n  font-style: italic;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"sans\";\r\n  src: local(\"sans\"),\r\n    url(\"./assets/fonts/sans/SourceSansPro-Light.otf\") format(\"opentype\");\r\n  font-weight: 300;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"sans\";\r\n  src: local(\"sans\"),\r\n    url(\"./assets/fonts/sans/SourceSansPro-LightIt.otf\") format(\"opentype\");\r\n  font-weight: 300;\r\n  font-style: italic;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"sans\";\r\n  src: local(\"sans\"),\r\n    url(\"./assets/fonts/sans/SourceSansPro-Semibold.otf\") format(\"opentype\");\r\n  font-weight: 700;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"sans\";\r\n  src: local(\"sans\"),\r\n    url(\"./assets/fonts/sans/SourceSansPro-SemiboldIt.otf\") format(\"opentype\");\r\n  font-weight: 700;\r\n  font-style: italic;\r\n} */\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
